import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{ color: "white" }} spin />;

class AdvancedButton extends React.Component {
  render() {
    const {
      text,
      onNext,
      isNext,
      submit,
      visible,
      disabled,
      isSmallText,
      isSmall,
      center,
      blue,
      bgblue,
      isBack,
    } = this.props;

    return (
      <>
        {visible == null || !visible ? (
          <button
            type={submit && "submit"}
            className={`advanced-button
          ${center ? "advanced-button--center" : ""}
          ${blue ? "advanced-button--blue" : ""}
          ${bgblue ? "advanced-button--bgblue" : ""}
          ${isSmall ? "advanced-button--small" : ""}
            `}
            onClick={onNext}
            disabled={disabled}
          >
            {disabled ? <Spin indicator={antIcon} /> : null}
            {isBack && !disabled ? (
              <img
                className="advanced-button__icon__rotate"
                src="/assets/img/icons/arrow-right.png"
                alt=""
              />
            ) : null}

            {!disabled ? (
              <span
                className={isSmallText ? "advanced-button__small-text" : null}
              >
                {text}
              </span>
            ) : null}

            {isNext ? (
              <img
                className="advanced-button__icon"
                src="/assets/img/icons/arrow-right.png"
                alt=""
              />
            ) : null}
            {blue ? (
              <img src="/assets/img/icons/arrow-right-blue.png" alt="" />
            ) : null}
          </button>
        ) : null}
      </>
    );
  }
}

export default AdvancedButton;
